let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3sWlT")).then(() => parcelRequire('fvHde'));